<template>
  <div :class="['sidebar-wrapper', { 'no-mobile-navbar': hideNavbarOnMobile }]">
    <!-- Mobile Toggle Button -->
    <b-button
      v-if="isMobile"
      v-b-toggle.sidebar-right
      class="mobile-toggle-btn sm btn btn-secondary"
      :class="{ active: isSidebarOpen }"
    >
      <b-icon icon="x" aria-hidden="true" v-if="isSidebarOpen"></b-icon>
      <b-icon icon="list" aria-hidden="true" v-else></b-icon>
    </b-button>

    <b-sidebar
      v-if="isMobile"
      id="sidebar-right"
      title="القائمة"
      right
      shadow
      class="sidebar-container"
      :visible="!isMobile"
      :no-header="true"
      :backdrop="isMobile"
      @hidden="onSidebarHidden"
      @shown="onSidebarShown"
    >
      <div class="sidebar" @click.stop>
        <div
          class="aside-nav d-flex flex-column justify-content-lg-center align-items-center flex-column-fluid"
        >
          <ul class="nav flex-column">
            <template v-for="(item, i) in menu" :key="i">
              <!-- Remove console.log from v-if condition -->
              <li v-if="shouldShowMenuItem(item)" class="nav-item">
                <router-link
                  v-if="!item.children"
                  :to="item.slug"
                  exact
                  class="nav-link"
                  @click="closeSidebar"
                >
                  <img :src="item.icon" :alt="item.title" class="me-2" />
                  <div>{{ item.title }}</div>
                </router-link>
                <div
                  v-else
                  class="nav-link w-100"
                  :class="{ 'router-link-active': isParentActive(item) }"
                >
                  <span
                    class="d-flex align-items-center parent-link w-100"
                    style="cursor: pointer"
                    @click="toggleSubmenu(item)"
                  >
                    <img
                      style="width: 20px; height: 20px"
                      :src="item.icon"
                      :alt="item.title"
                      class="me-2"
                    />
                    <div
                      class="d-flex align-items-center justify-content-between w-100"
                    >
                      {{ item.title }}
                    </div>
                    <span>
                      <b-icon icon="chevron-up" v-if="item.isOpen" />
                      <b-icon icon="chevron-down" v-else />
                    </span>
                  </span>

                  <Transition name="fade">
                    <ul v-if="item.isOpen" class="nav flex-column submenu mt-2">
                      <template
                        v-for="(child, j) in item.children"
                        :key="j.slug"
                      >
                        <li
                          v-if="shouldShowMenuItem(child)"
                          class="nav-item ms-2"
                        >
                          <router-link
                            :to="child.slug"
                            exact
                            class="nav-link"
                            :class="{
                              'router-link-active': route.path === child.slug,
                            }"
                            @click="closeSidebar"
                          >
                            <img
                              style="width: 16px; height: 16px"
                              :src="child.icon"
                              :alt="child.title"
                              class="me-2"
                            />
                            <div>
                              {{ child.title }}
                            </div>
                          </router-link>
                        </li>
                      </template>
                    </ul>
                  </Transition>
                </div>
              </li>
            </template>
          </ul>
          <!-- <b-nav-item-dropdown
            class="nav-item"
            text="التقييم"
            toggle-class="nav-link"
          >
            <template #button-content>
              <div>التقييم</div>
            </template>
            <b-dropdown-item
              to="/manage-initial-inspections-requests"
              class="nav-link"
              @click="closeSidebar"
            >
              التقييم التفصيلي
            </b-dropdown-item>
            <b-dropdown-item
              to="/manage-detailed-inspections-requests"
              class="nav-link"
              @click="closeSidebar"
            >
              التقييم التفصيلي
            </b-dropdown-item>
            <b-dropdown-item
              to="/evaluation"
              class="nav-link"
              @click="closeSidebar"
            >
              قوالب التقييم التفصيلي
            </b-dropdown-item>
            <b-dropdown-item
              to="/detailed-evaluation"
              class="nav-link"
              @click="closeSidebar"
            >
              قوالب التقييم التفصيلي التقييم التفصيلي
            </b-dropdown-item>
          </b-nav-item-dropdown> -->
        </div>
      </div>
    </b-sidebar>
    <div v-else class="sidebar">
      <div
        class="aside-nav d-flex flex-column justify-content-lg-center align-items-center flex-column-fluid"
      >
        <ul class="nav flex-column">
          <template v-for="(item, i) in menu" :key="i">
            <li class="nav-item" v-if="shouldShowMenuItem(item)">
              <router-link
                v-if="!item.children"
                :to="item.slug"
                exact
                class="nav-link"
                @click="closeSidebar"
              >
                <img
                  style="width: 20px; height: 20px"
                  :src="item.icon"
                  :alt="item.title"
                  class="me-2"
                />
                <div>
                  {{ item.title }}
                </div>
              </router-link>
              <div
                v-else
                class="nav-link w-100"
                :class="{ 'router-link-active': isParentActive(item) }"
              >
                <span
                  class="d-flex align-items-center parent-link w-100"
                  style="cursor: pointer"
                  @click="item.isOpen = !item.isOpen"
                >
                  <img
                    style="width: 20px; height: 20px"
                    :src="item.icon"
                    :alt="item.title"
                    class="me-2"
                  />
                  <div
                    class="d-flex align-items-center justify-content-between w-100"
                  >
                    {{ item.title }}
                  </div>
                  <span>
                    <b-icon icon="chevron-up" v-if="item.isOpen" />
                    <b-icon icon="chevron-down" v-else />
                  </span>
                </span>
                <Transition name="fade">
                  <ul v-if="item.isOpen" class="nav flex-column submenu mt-2">
                    <template v-for="(child, j) in item.children" :key="j.slug">
                      <li class="nav-item ms-2" v-if="shouldShowMenuItem(child)">
                        <router-link
                          :to="child.slug"
                          exact
                          class="nav-link"
                          :class="{
                            'router-link-active': route.path === child.slug,
                          }"
                          @click="closeSidebar"
                        >
                          <img
                            style="width: 16px; height: 16px"
                            :src="child.icon"
                            :alt="child.title"
                            class="me-2"
                          />
                          <div>
                            {{ child.title }}
                          </div>
                        </router-link>
                      </li>
                    </template>
                  </ul>
                </Transition>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import controlPanelIcon from "@/assets/icons/side-nav/control-panel.svg";
import managementInspectionIcon from "@/assets/icons/side-nav/management-inspection.svg";
import dashboardIcon from "@/assets/icons/side-nav/dashboard.svg";
import inspectionRequestsIcon from "@/assets/icons/side-nav/inspection-requests.svg";
import userIcon from "@/assets/icons/side-nav/user.svg";
import DetailedInspectionIcon from "@/assets/icons/side-nav/context-data-details.svg";
import addNewInspections from "@/assets/icons/side-nav/create-svgrepo-com.svg";
import buildingsIcon from "@/assets/icons/side-nav/building-svgrepo-com.svg";
import buildingsClassificationIcon from "@/assets/icons/side-nav/classification-buildings.svg";
import settingsIcon from "@/assets/icons/side-nav/setting-5-svgrepo-com.svg";
import orgStructuresIcon from "@/assets/icons/side-nav/org-structures.svg";
import GeneralSettingsIcon from "@/assets/icons/side-nav/general-settings.svg";
import usersIcon from "@/assets/icons/side-nav/user.svg";
import classificationsIcon from "@/assets/icons/side-nav/classification.svg";
import blanksIcon from "@/assets/icons/side-nav/blanks.svg";
import logsIcon from "@/assets/icons/side-nav/general-settings.svg";
import { Transition } from "vue";
import { REQUIRED_ROLES } from "@/router/rquired-roles";
import store from "@/store";
import { MOBILE_UI_CONFIG } from "@/config/mobile-ui";

export default {
  setup() {
    // Reactive state for sidebar
    const isSidebarOpen = ref(false);
    const screenWidth = ref(window.innerWidth);
    const visible = ref(false); // Initialize as collapsed
    const route = useRoute();
    const router = useRouter();
    const userRoles = store.getters.roles;

    // Compute if current device is mobile (screen size)
    const isMobile = computed(() => screenWidth.value < 768);

    // Check if user is accessing from mobile app (Flutter WebView)
    const isMobileApp = computed(() => store.getters["user/isMobileApp"]);
    const hideNavbarOnMobile = computed(
      () => isMobileApp.value && !MOBILE_UI_CONFIG.showNavbarOnMobile
    );

    // Debug: Log mobile app status
    console.log('[Sidebar] isMobileApp from Vuex:', isMobileApp.value);
    console.log('[Sidebar] isMobileApp from Cookie:', document.cookie.includes('Is-Mobile-App=true'));

    // Check if parent menu item should be active
    const isParentActive = (item) => {
      return item.children?.some((child) => route.path === child.slug);
    };

    // Check if menu item should be shown based on user permissions AND platform
    const shouldShowMenuItem = (item) => {
      // First check if user has permission
      if (!item.isAuthed) return false;
      
      // If user is on mobile app (Flutter)
      if (isMobileApp.value) {
        // Hide items marked with showOnMobile: false
        if (item.showOnMobile === false) return false;
        // Show everything else (including mobileOnly items)
        return true;
      }

      // If user is on desktop web
      else {
        // Hide items marked with mobileOnly: true
        if (item.mobileOnly === true) return false;
        // Show everything else
        return true;
      }
    };

    // Toggle sidebar open
    const toggleSidebar = () => {
      isSidebarOpen.value = !isSidebarOpen.value;
    };

    // Toggle submenu
    const toggleSubmenu = (item) => {
      item.isOpen = !item.isOpen;
    };

    // Close sidebar
    const closeSidebar = () => {
      isSidebarOpen.value = false;
    };

    // Sidebar shown handler
    const onSidebarShown = () => {
      isSidebarOpen.value = true;
    };

    // Sidebar hidden handler
    const onSidebarHidden = () => {
      isSidebarOpen.value = false;
    };

    // Handle responsive behavior
    const handleResize = () => {
      screenWidth.value = window.innerWidth;
    };

    // Add and remove resize listener
    onMounted(() => {
      window.addEventListener("resize", handleResize);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    const menu = ref(
      [
        {
          title: "لوحة المراقبة",
          slug: "/statistics",
          icon: dashboardIcon,
          requiredRoles: REQUIRED_ROLES.statistics,
          isAuthed: REQUIRED_ROLES.statistics.some((role) =>
            userRoles.includes(role)
          ),
          showOnMobile: false,
        },
        {
         title: "قوالب التقييم",
         slug: "/evaluation",
         icon: controlPanelIcon,
         requiredRoles: REQUIRED_ROLES["initial-evaluation"],
         isAuthed: REQUIRED_ROLES["initial-evaluation"].some((role) =>
           userRoles.includes(role)
         ),
         showOnMobile: false,
        },

        {
          title: "التقارير",
          icon: managementInspectionIcon,
          isOpen: false,
          requiredRoles: REQUIRED_ROLES["manage-inspections-requests"],
          isAuthed: REQUIRED_ROLES["manage-inspections-requests"].some((role) => userRoles.includes(role)),
          showOnMobile: false,
          children: [
            {
              title: "كفاءة مباني ومرافق وزارة البلديات والإسكان",
              slug: "/reports/buildings-efficiency",
              icon: inspectionRequestsIcon,
              requiredRoles:
                REQUIRED_ROLES["manage-initial-inspections-requests"],
              isAuthed: REQUIRED_ROLES[
                "manage-initial-inspections-requests"
              ].some((role) => userRoles.includes(role)),
            },
            {
              title: "التقييم التفصيلي على مستوى المبنى",
              slug: "/reports/building-detailed-evaluation",
              icon: inspectionRequestsIcon,
              requiredRoles:
                REQUIRED_ROLES["manage-inspections-requests"],
              isAuthed: REQUIRED_ROLES[
                "manage-inspections-requests"
              ].some((role) => userRoles.includes(role)),
            },
            {
              title: "السعة والطلب",
              slug: "/reports/capacity-and-demand",
              icon: inspectionRequestsIcon,
              requiredRoles:
                REQUIRED_ROLES["manage-inspections-requests"],
              isAuthed: REQUIRED_ROLES[
                "manage-inspections-requests"
              ].some((role) => userRoles.includes(role)),
            },
            {
              title: "تقرير السعه والطلب التفصيلي",
              slug: "/reports/new-capacity-and-demand",
              icon: inspectionRequestsIcon,
              requiredRoles:
                REQUIRED_ROLES["manage-inspections-requests"],
              isAuthed: REQUIRED_ROLES["manage-inspections-requests"].some((role) => userRoles.includes(role)),
            },
          ],
        },
        {
          title: "طلبات التقييم",
          icon: managementInspectionIcon,
          isOpen: false,
          requiredRoles: REQUIRED_ROLES["manage-inspections-requests"],
          isAuthed: REQUIRED_ROLES["manage-inspections-requests"].some((role) => userRoles.includes(role)),
          children: [
            {
              title: "طلبات التقييم الاولية",
              slug: "/manage-initial-inspections-requests",
              icon: inspectionRequestsIcon,
              requiredRoles:
                REQUIRED_ROLES["manage-initial-inspections-requests"],
              isAuthed: REQUIRED_ROLES[
                "manage-initial-inspections-requests"
              ].some((role) => userRoles.includes(role)),
            },
            {
              title: "طلبات التقييم التفصيلية",
              slug: "/manage-detailed-inspections-requests",
              icon: DetailedInspectionIcon,
              requiredRoles:
                REQUIRED_ROLES["manage-inspections-requests"],
              isAuthed: REQUIRED_ROLES[
                "manage-inspections-requests"
              ].some((role) => userRoles.includes(role)),
            },
          ],
        },
        {
          title: "طلبات الفحص الاولية",
          slug: "/inspection-requests",
          icon: inspectionRequestsIcon,
          requiredRoles: REQUIRED_ROLES["inspection-requests"],
          isAuthed: REQUIRED_ROLES["inspection-requests"].some((role) =>
            userRoles.includes(role)
          ),
        },
        {
          title: "طلبات الفحص التفصيلية",
          slug: "/inspection-requests-v2",
          icon: inspectionRequestsIcon,
          requiredRoles: REQUIRED_ROLES["detailed-inspection-requests"],
          isAuthed: REQUIRED_ROLES["detailed-inspection-requests"].some((role) =>
            userRoles.includes(role)
          ),
        },
        // {
        //   title: "طلبات الفحص التفصيلية",
        //   slug: "/detailed-inspection-requests",
        //   icon: DetailedInspectionIcon,
        //   requiredRoles: REQUIRED_ROLES["detailed-inspection-requests"],
        //   isAuthed: REQUIRED_ROLES["detailed-inspection-requests"].some(
        //     (role) => userRoles.includes(role)
        //   ),
        // },
        {
          title: "البيانات الاساسية",
          icon: settingsIcon,
          isOpen: false,
          requiredRoles: [
            ...REQUIRED_ROLES["buildings-settings"],
            ...REQUIRED_ROLES["buildings-classification"],
            ...REQUIRED_ROLES["org-structures"],
            ...REQUIRED_ROLES["elements-classifications"],
            ...REQUIRED_ROLES["blanks"],
            ...REQUIRED_ROLES["users"],
          ],
          isAuthed: [
            ...REQUIRED_ROLES["buildings-settings"],
            ...REQUIRED_ROLES["buildings-classification"],
            ...REQUIRED_ROLES["org-structures"],
            ...REQUIRED_ROLES["elements-classifications"],
            ...REQUIRED_ROLES["blanks"],
            ...REQUIRED_ROLES["users"],
          ].some((role) => userRoles.includes(role)),
          children: [
            {
              title: "المباني",
              slug: "/buildings-settings",
              icon: buildingsIcon,
              requiredRoles: REQUIRED_ROLES["buildings-settings"],
              isAuthed: REQUIRED_ROLES["buildings-settings"].some((role) =>
                userRoles.includes(role)
              ),
            },
            {
              title: "تصنيف المباني",
              slug: "/buildings-classification",
              icon: buildingsClassificationIcon,
              requiredRoles: REQUIRED_ROLES["buildings-classification"],
              isAuthed: REQUIRED_ROLES["buildings-classification"].some(
                (role) => userRoles.includes(role)
              ),
            },
            {
              title: "الجهات",
              slug: "/org-structures",
              icon: orgStructuresIcon,
              requiredRoles: REQUIRED_ROLES["org-structures"],
              isAuthed: REQUIRED_ROLES["org-structures"].some((role) =>
                userRoles.includes(role)
              ),
            },
                        // {
            //   title: "تصنيف العناصر",
            //   slug: "/elements-classifications",
            //   icon: classificationsIcon,
            //   requiredRoles: REQUIRED_ROLES["elements-classifications"],
            //   isAuthed: REQUIRED_ROLES["elements-classifications"].some(
            //     (role) => userRoles.includes(role)
            //   ),
            // },
            // {
            //   title: "الفراغات",
            //   slug: "/blanks",
            //   icon: blanksIcon,
            //   requiredRoles: REQUIRED_ROLES["blanks"],
            //   isAuthed: REQUIRED_ROLES["blanks"].some((role) =>
            // userRoles.includes(role)
            //   ),
            // },
            {
              title: "المستخدمين",
              slug: "/users",
              icon: usersIcon,
              requiredRoles: REQUIRED_ROLES["users"],
              isAuthed: REQUIRED_ROLES["users"].some((role) =>
                userRoles.includes(role)
              ),
            },
          ],
        },
        {
          title: "سجل احداث النظام",
          icon: logsIcon,
          slug: "/logs",
          requiredRoles: REQUIRED_ROLES["logs"],
          isAuthed: REQUIRED_ROLES["logs"].some((role) =>
            userRoles.includes(role)
          ),
          showOnMobile: false,
        },
        {
          title: "سجل الأحداث",
          icon: logsIcon,
          slug: "/audit-trail",
          requiredRoles: REQUIRED_ROLES["audit-trail"],
          isAuthed: REQUIRED_ROLES["audit-trail"].some((role) =>
            userRoles.includes(role)
          ),
          showOnMobile: false,
        },
        {
          title: "الاعدادات العامة",
          icon: GeneralSettingsIcon,
          slug: "/general-settings",
          requiredRoles: REQUIRED_ROLES["general-settings"],
          isAuthed: REQUIRED_ROLES["general-settings"].some((role) =>
            userRoles.includes(role)
          ),
          showOnMobile: false, // Hide from mobile app users
        },
      ].filter((item) => {
        // If item has no children, check its own authorization
        if (!item.children) {
          return item.isAuthed;
        }

        // If item has children, check if any child is authorized
        const hasAuthorizedChild = item.children.some(
          (child) => child.isAuthed
        );
        if (hasAuthorizedChild) {
          // Filter the children to only show authorized ones
          item.children = item.children.filter((child) => child.isAuthed);
          return true;
        }
        return false;
      })
    );
    return {
      menu,
      isSidebarOpen,
      isMobile,
      toggleSidebar,
      toggleSubmenu,
      closeSidebar,
      onSidebarShown,
      onSidebarHidden,
      visible,
      isParentActive,
      shouldShowMenuItem,
      route,
      userRoles,
      hideNavbarOnMobile,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "./sidebar";

.sidebar-wrapper {
  // Ensure proper positioning
  position: relative;
  z-index: 1;
  
  // Mobile responsive adjustments
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1050;
  }
}

.mobile-toggle-btn {
  position: fixed;
  top: 110px;
  right: 15px;
  z-index: 1100;
  background: $primary-bg;
  // color: $secondary-bg;
  border: none;
  padding: 5px;
  border-radius: 5px;
  
  // Improved mobile styling
  @media (max-width: 768px) {
    top: 80px; // Adjust for new navbar height
    background: $primaryColor;
    color: white;
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    
    &:hover {
      transform: scale(1.05);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }
    
    &.active {
      background: $primaryColor;
      transform: rotate(180deg);
    }
  }
  
  @media (max-width: 480px) {
    top: 70px;
    right: 10px;
    padding: 6px;
  }
}

.nav-link {
  &.div {
    background: rgba(44, 181, 181, 0.09);
    color: #188c8b;
  }
}

.submenu {
  padding-left: 20px;

  .nav-link {
    padding: 8px 15px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.sidebar {
  height: calc(100vh - 100px); // Adjust height to account for header
  overflow-y: auto; // Enable scrolling
  padding-bottom: 60px; // Add padding at bottom
  
  // Mobile responsive sidebar
  @media (max-width: 768px) {
    height: calc(100vh - 80px);
    padding-bottom: 40px;
  }
  
  @media (max-width: 480px) {
    height: calc(100vh - 70px);
    padding-bottom: 30px;
  }
}

.sidebar-wrapper.no-mobile-navbar .sidebar {
  height: 100vh;
  padding-bottom: 60px;
}

@media (max-width: 768px) {
  .sidebar-wrapper.no-mobile-navbar .mobile-toggle-btn {
    top: 20px;
  }

  .sidebar-wrapper.no-mobile-navbar .sidebar {
    height: 100vh;
    padding-bottom: 40px;
  }
}

@media (max-width: 480px) {
  .sidebar-wrapper.no-mobile-navbar .mobile-toggle-btn {
    top: 16px;
  }

  .sidebar-wrapper.no-mobile-navbar .sidebar {
    padding-bottom: 30px;
  }
}

@media (min-width: 768px) {
  // Desktop styles
  .mobile-toggle-btn {
    display: none;
  }

  // Ensure sidebar is visible on desktop
  :deep .b-sidebar {
    // Ensure sidebar is always visible on desktop
    transform: translateX(0) !important;
    visibility: visible !important;
  }
}

// Enhanced mobile sidebar styles
@media (max-width: 768px) {
  :deep .b-sidebar {
    .b-sidebar-body {
      padding: 0;
      background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    }
    
    .sidebar {
      .nav {
        padding: 20px 0;
        
        .nav-item {
          margin-bottom: 8px;
          
          .nav-link {
            padding: 12px 20px;
            border-radius: 0 25px 25px 0;
            margin-right: 10px;
            transition: all 0.3s ease;
            border-left: 4px solid transparent;
            
            &:hover, &.router-link-active {
              background: rgba($primaryColor, 0.1);
              border-left-color: $primaryColor;
              transform: translateX(5px);
            }
            
            img {
              width: 20px;
              height: 20px;
              filter: brightness(0.8);
            }
            
            div {
              font-size: 14px;
              font-weight: 500;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
  
  // Better backdrop for mobile
  :deep .b-sidebar-backdrop {
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
  }
}
</style>
